import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfAverageScreentimeScoreEntity } from '../../../core/domain/entities/scores/self-average-screentime-score.entity';

export interface ISelfAverageScreentimeScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.TotalActivityDuration]: string;
  [IWorkingSessionsAnalyticsActivityEnum.DayCount]?: string;
  [IWorkingSessionsAnalyticsActivityEnum.WeekCount]?: string;
}

export class SelfAverageScreentimeScoreMapper
  implements Omit<Mapper<SelfAverageScreentimeScoreEntity, any>, 'toResponse'>
{
  toDomain(
    record: ISelfAverageScreentimeScorePersistenceResponse
  ): SelfAverageScreentimeScoreEntity {
    return SelfAverageScreentimeScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfAverageScreentimeScorePersistenceResponse
  ): SelfAverageScreentimeScoreEntity {
    const entity = SelfAverageScreentimeScoreEntity.create({
      screentimeScore: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalActivityDuration]
      ),
      count: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.WeekCount] ??
          record[IWorkingSessionsAnalyticsActivityEnum.DayCount]
      ),
    });
    return entity;
  }
}
